import React, {Component} from "react";
import {ControlPanelService} from "../../../service/controlPanel/ControlPanelService";
import {CONTROL_PANEL_ROUTE} from "../../../utils/constants/RoutesConstants";
import NewLoan from "./newLoanView";

export default class NewLoanContainer extends Component {
    constructor(props) {
        super(props);

        this.controlPanelService = new ControlPanelService();

        this.loading = this.loading.bind(this);
        this.handleReturnButton = this.handleReturnButton.bind(this);
        this.getNewLoan = this.getNewLoan.bind(this);


        this.state = {
            isLoading: true,
            loanId: this.props.location.state.folio,
            loan: [],
            newLoan: [],
            guarantee: [],
        };

        this.getNewLoan(this.props.location.state.folio);
    }

    getNewLoan(loanId) {
        this.loading(true);
        this.controlPanelService.getNewLoan(this.props.location.state.folio).then(
            response => {
                let newLoan = '[' +
                    '{"plazo":"' + response[2] + '",' +
                    '"tasa":"' + response[3] + '",' +
                    '"sobreTasa":"' + response[4] + '",' +
                    '"premio":"' + response[5] + '",' +
                    '"CantDisp":"' + response[6] + '"}' +
                    ']';


                this.setState({
                    loan: [response[0]],
                    newLoan: JSON.parse(newLoan),
                    guarantee: response[1],
                });
                this.loading(false);
            });
    }

    loading(isLoading) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: isLoading
            });
        }
    }

    handleReturnButton() {
        this.props.history.push({
            pathname: CONTROL_PANEL_ROUTE,
        });
    }

    render() {
        return <NewLoan
            isLoading={this.state.isLoading}
            loading={this.loading}
            handleReturnButton={this.handleReturnButton}
            loan={this.state.loan}
            newLoan={this.state.newLoan}
            guarantee={this.state.guarantee}
        />

    }
};